export default __webpack_public_path__ + "lionfish_spotlight.bd61a727.png";